
import Banner from './banner/';
import Unidades from './unidades';
import './Home.css';
import { Link, Element, scroller } from 'react-scroll';
import Video from './video';
import Citacao from './citacao';


const Home = () => {


    return (
        <>
            <Banner />
            <Unidades />
            <Video />
            <Citacao />
        </>
    )
}

export default Home;
